'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ = require('../../');

var _fbemitter = require('fbemitter');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeckoToastService = function () {
	_createClass(GeckoToastService, [{
		key: 'emitter',
		get: function get() {
			return GeckoToastService.emitter;
		},
		set: function set(value) {
			GeckoToastService.emitter = value;
		}
	}, {
		key: 'items',
		get: function get() {
			return GeckoToastService.items;
		},
		set: function set(value) {
			GeckoToastService.items = value;
		}
	}]);

	function GeckoToastService() {
		_classCallCheck(this, GeckoToastService);

		// Create toast event emitter (if not already created)
		if (!this.emitter) this.emitter = new _fbemitter.EventEmitter();
	}

	_createClass(GeckoToastService, [{
		key: 'add',
		value: function add(toast) {
			var _this = this;

			// https://ux.stackexchange.com/questions/11203/how-long-should-a-temporary-notification-toast-appear
			var timeOutLim = 3000;
			if (toast.message.length * 50 > 3000) {
				timeOutLim = toast.message.length * 50;
				if (timeOutLim > 7000) {
					timeOutLim = 7000;
				}
			}
			// Add toast
			this.items.push(toast);
			// Remove toast (after timeout)
			toast.timeout = setTimeout(function () {
				_this.remove(toast);
			}, timeOutLim);

			this.emitter.emit('update');
		}
	}, {
		key: 'remove',
		value: function remove(toastToRemove) {
			// Clear timeout
			if (toastToRemove.timeout) clearTimeout(toastToRemove.timeout);
			// Remove toast from toasts array
			this.items = this.items.filter(function (toast) {
				return toast !== toastToRemove;
			});

			this.emitter.emit('update');
		}
	}, {
		key: 'success',
		value: function success(message) {
			this.add({
				message: message,
				type: _.GECKO_CONSTS.TOAST_TYPE_SUCCESS
			});
		}
	}, {
		key: 'warning',
		value: function warning(message) {
			this.add({
				message: message,
				type: _.GECKO_CONSTS.TOAST_TYPE_WARNING
			});
		}
	}, {
		key: 'error',
		value: function error(message) {
			this.add({
				message: _.GECKO_UTILS.renderError(message),
				type: _.GECKO_CONSTS.TOAST_TYPE_ERROR
			});
		}
	}]);

	return GeckoToastService;
}();

GeckoToastService.items = [];
exports.default = GeckoToastService;